import { render, staticRenderFns } from "./AdminAgreementDetail.vue?vue&type=template&id=0b6d2afe&scoped=true"
import script from "./AdminAgreementDetail.vue?vue&type=script&lang=js"
export * from "./AdminAgreementDetail.vue?vue&type=script&lang=js"
import style0 from "./AdminAgreementDetail.vue?vue&type=style&index=0&id=0b6d2afe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6d2afe",
  null
  
)

export default component.exports